import { ApprovalsPage } from '@/features/approvals';
import { LoginPage } from '@/features/auth';
import { useAuth } from '@/shared/auth/auth-context';
import { EventConfigProvider } from '@/shared/config/EventConfigProvider';

/**
 * Raiz da aplicação.
 *
 * Não há roteador: o painel tem uma única tela e um portão de autenticação.
 * Introduzir `react-router` aqui só adicionaria uma dependência e um nível de
 * indireção — se surgirem novas telas, é o primeiro ponto a revisitar.
 *
 * A parametrização é carregada dentro do portão, e não em volta dele: a tela de
 * login não depende dela, e esperar a requisição antes do formulário atrasaria o
 * login por um dado que só o painel usa.
 */
export function App() {
  const { session } = useAuth();

  if (!session) return <LoginPage />;

  return (
    <EventConfigProvider>
      <ApprovalsPage />
    </EventConfigProvider>
  );
}
